import { IContract, INicknameInfo, IOutbidAsset, IOutbidSale, IOutbidUserSaleBids } from "../../utils/interfaces";

export interface IOutbidState {
  initLoading: boolean;
  outbids: { [key: string]: IOutbidSale };
  outbidAssets: { [key: string]: IOutbidAsset };
  outbidContracts: { [key: string]: IContract };
  outbidServerTime: number | null;
  outbidUser: {
    salesBids: { [key: string]: IOutbidUserSaleBids } | null;
    outbidAssetBalances: { [key: string]: number };
  };
  nicknames: { [key: string]: INicknameInfo };
}

const state: IOutbidState = {
  initLoading: true,
  outbids: {},
  outbidAssets: {},
  outbidContracts: {},
  outbidServerTime: null,
  outbidUser: {
    salesBids: null,
    outbidAssetBalances: {},
  },
  nicknames: {},
};

export default state;
